import axios from 'axios';
import {CONSTANT} from '../shared/constant'
import * as _ from 'lodash'


const callApi = async function (endpoint: string, method = 'GET', body:any = null, version = '', token?: any, checkToken:boolean = false) {

    let API_URL = CONSTANT.baseUrl + (version ? version : CONSTANT.apiVersion)
    if (endpoint.charAt(0) == '/') {
        endpoint = endpoint.substring(1);
    }
            
    // token === true nghĩa là "API này không bắt buộc đăng nhập" (login, register,
    // các endpoint /public/...). Trước đây giá trị true rơi thẳng vào header
    // thành `Authorization: Bearer true` - một token rác gửi lên mọi lời gọi
    // công khai. Dùng token thật nếu có, không có thì không gửi header.
    if (token === true) {
        // true = "không bắt buộc đăng nhập": vẫn phải gọi kể cả khi chưa có token,
        // nên bật luôn checkToken để không rơi vào nhánh return false bên dưới.
        checkToken = true
        token = (await getTokenFromStorageData()) || null
    }

    if (!token && !checkToken) {
        token = await getTokenFromStorageData()
        if(!token) return false 
    }
    const buildHeaders = (currentToken: any) => {
        const headers: any = {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            "Accept-Language": "*",
        }
        if (currentToken) {
            headers.Authorization = 'Bearer ' + currentToken
        }
        return headers
    }

    // Tham số GET phải gắn vào URL đúng một lần: gắn bên trong hàm gọi thì lần
    // gọi lại sau khi làm mới token sẽ nối thêm một lần nữa.
    // PATCH gửi body như POST, không đẩy vào query string.
    if (method !== 'POST' && method !== 'PATCH' && method !== 'DELETE' && !_.isEmpty(body)) {
        let paramsArr: string[] = []
        _.forOwn(body, (val, key) => {
            paramsArr.push(`${key}=${val}`);
        })
        if (paramsArr.length > 0) {
            if (endpoint.indexOf("?") === -1) {
                endpoint += "?"
            }
            endpoint += paramsArr.join("&")
        }
    }

    const callApiData = async (currentToken: any) => {
        const headers = buildHeaders(currentToken)
        switch (method) {
            case 'POST':
                return await axios.post(`${API_URL}/${endpoint}`, body, { headers })
            case 'PATCH':
                return await axios.patch(`${API_URL}/${endpoint}`, body, { headers })
            case 'DELETE':
                return await axios.delete(`${API_URL}/${endpoint}`, { headers })
            default:
                return await axios.get(`${API_URL}/${endpoint}`, { headers })
        }
    }

    const unwrapResponse = (response: any) => (response.data ? response.data : null)

    try {
        return unwrapResponse(await callApiData(token))
    } catch (e: any) {
        // Access token hết hạn: xin token mới bằng refresh token rồi gọi lại đúng
        // một lần. Chỉ làm khi lời gọi này thực sự mang token, và không áp cho
        // chính các API auth (login/refresh sai thì phải báo lỗi như thường).
        const retriable = e?.response?.status === 401 && !!token && !endpoint.startsWith('auth/')
        if (!retriable) {
            throw e
        }
        const freshToken = await ensureFreshToken()
        if (!freshToken) {
            throw e
        }
        return unwrapResponse(await callApiData(freshToken))
    }
}


const callExternalApi = async function (endpoint: string, method = 'GET', body = null, headers: any) {
    const callApiData = async () => {
        switch (method) {
            case 'POST':
                const postPromise =  await axios.post(`${endpoint}`, body, {
                    headers:  headers
                })
                // using .then, create a new promise which extracts the data
                // return it
                return postPromise
                break;
            default:
                if (!_.isEmpty(body)) {
                    let parameters = ''
                    _.forOwn(body, function (val:any, key: string) {
                        parameters += `&${key}=${val}`
                    })
                    if (endpoint.indexOf('?') > -1) {
                        endpoint += parameters
                    } else {
                        endpoint += ('?' + parameters.substring(1))
                    }
                }
              
                const promise = await axios.get(`${endpoint}`, {
                    headers:  headers
                })
                // using .then, create a new promise which extracts the data

                // return it
                return promise
        }
    }


    let rsp = callApiData().then((response) => response.data)
    return rsp
}

const getTokenFromStorageData = async function () {
    return localStorage.getItem('token');
}

const getRefreshTokenFromStorageData = function () {
    return localStorage.getItem('refreshToken');
}

/**
 * Xin access token mới bằng refresh token.
 *
 * POST /v1/auth/refresh nhận refresh token ở header Authorization, trả về
 * { token, refreshToken, tokenExpires } và backend bọc trong { data } nên phải
 * bóc. Refresh token cũng được cấp lại, phải lưu đè.
 *
 * Bản cũ của hàm này truyền headers vào chỗ body của axios.post nên không bao
 * giờ gửi được Authorization - và nó chưa từng được gọi ở đâu.
 */
const doRefreshToken = async (): Promise<string | null> => {
    const storedRefreshToken = getRefreshTokenFromStorageData()
    if (!storedRefreshToken) {
        return null
    }

    // baseUrl có môi trường kết thúc bằng '/', có môi trường thì không - nối thô
    // sẽ ra .../apiv1/auth/refresh và refresh im lặng hỏng.
    const base = CONSTANT.baseUrl.endsWith('/') ? CONSTANT.baseUrl : CONSTANT.baseUrl + '/'
    const API_URL = base + 'v1'
    try {
        const response = await axios.post(`${API_URL}/auth/refresh`, {}, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Accept-Language": "*",
                "Authorization": "Bearer " + storedRefreshToken,
            }
        })
        const data = response?.data?.data ?? response?.data
        if (!data?.token) {
            return null
        }
        localStorage.setItem('token', data.token)
        if (data.refreshToken) {
            localStorage.setItem('refreshToken', data.refreshToken)
        }
        return data.token
    } catch (e: any) {
        // Refresh token cũng hết hạn: dọn sạch để lần gọi /players/me kế tiếp rơi
        // vào nhánh "phiên đã hết hạn" ở Layout.
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('userInfo')
        return null
    }
}

/**
 * Nhiều request cùng dính 401 thì chỉ gọi refresh một lần, những request còn lại
 * chờ chung kết quả - nếu không, mỗi màn hình lại xoay một token mới và làm token
 * vừa cấp trước đó thành vô nghĩa.
 */
let refreshInFlight: Promise<string | null> | null = null

const ensureFreshToken = (): Promise<string | null> => {
    if (!refreshInFlight) {
        refreshInFlight = doRefreshToken().finally(() => {
            refreshInFlight = null
        })
    }
    return refreshInFlight
}

export {
    callApi,
    callExternalApi
}
